'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSeed$002dId$0024 from "./presto.types$-Seed-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$63() {
  this.aHS = null;
  this.aHQ = null;
  this.aHR = false;
  this.aHO = null;
  this.aHP = false;
  this.aHT = false;
  this.aHU = false;
  this.aHS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$63 as $c_Lpresto_CredentialsView$$anon$63 };
$p = $c_Lpresto_CredentialsView$$anon$63.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$63;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$63() {
}
export { $h_Lpresto_CredentialsView$$anon$63 as $h_Lpresto_CredentialsView$$anon$63 };
$h_Lpresto_CredentialsView$$anon$63.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aHS;
});
$p.t = (function() {
  if ((!this.aHR)) {
    this.aHQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seed", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHR = true;
  }
  return this.aHQ;
});
$p.ag = (function() {
  if ((!this.aHP)) {
    this.aHO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSeed$002dId$0024.$m_Lpresto_types$SeedId$().csZ(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHP = true;
  }
  return this.aHO;
});
$p.v = (function() {
  if ((!this.aHU)) {
    this.aHT = false;
    this.aHU = true;
  }
  return this.aHT;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$63 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$63, "presto.CredentialsView$$anon$63", ({
  Gc: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$63 as $d_Lpresto_CredentialsView$$anon$63 };
//# sourceMappingURL=presto.-Credentials-View$$anon$63.js.map
